<template>
  <div>
    <v-dialog
      v-model="dialog"
      scrollable
      max-width="90vw"
      @click:outside="discardItem"
    >
      <v-card>
        <v-card-title class="d-flex align-start justify-space-between">
          <p>{{ title }}</p>
          <v-btn icon @click="discardItem">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="better-scrollbar">
          <v-container fluid>
            <v-row no-gutters>
              <v-col cols="12" md="6" class="pa-2">
                <v-text-field
                  v-model="object.name"
                  :label="$t('courses.name')"
                  :disabled="!isEditting || object.isExternal"
                  outlined
                  :error="hasErrors('name')"
                  :error-messages="getErrors('name')"
                />
              </v-col>
              <v-col
                cols="12"
                md="6"
                class="pa-2"
              >
                <v-dialog
                  ref="colorDialog"
                  v-model="modal.color"
                  :return-value.sync="object.color"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="object.color"
                      :label="$t('courses.color')"
                      :disabled="!isEditting || object.isExternal"
                      outlined
                      :error="hasErrors('color')"
                      :error-messages="getErrors('color')"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <template v-slot:append>
                        <v-avatar
                          size="22"
                          :color="object.color"
                        />
                      </template>
                    </v-text-field>
                  </template>
                  <v-card>
                    <v-card-text class="pa-0">
                      <v-color-picker
                        v-model="object.color"
                        dot-size="10"
                        hide-inputs
                        hide-mode-switch
                        hide-sliders
                        show-swatches
                        swatches-max-height="200"
                      />
                    </v-card-text>
                    <v-card-actions class="d-flex justify-space-between">
                      <v-btn
                        text
                        color="primary"
                        @click="modal.color = false"
                      >
                        {{ $t('actions.discard') }}
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.colorDialog.save(object.color)"
                      >
                        {{ $t('actions.ok') }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-col>
              <v-col
                cols="12"
                md="6"
                class="pa-2"
              >
                <v-dialog
                  ref="holeColorDialog"
                  v-model="modal.holeColor"
                  :return-value.sync="object.holeColor"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="object.holeColor"
                      :label="$t('courses.holeColor')"
                      :disabled="!isEditting || object.isExternal"
                      outlined
                      :error="hasErrors('holeColor')"
                      :error-messages="getErrors('holeColor')"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <template v-slot:append>
                        <v-avatar
                          size="22"
                          :color="object.holeColor"
                        />
                      </template>
                    </v-text-field>
                  </template>
                  <v-card>
                    <v-card-text class="pa-0">
                      <v-color-picker
                        v-model="object.holeColor"
                        dot-size="10"
                        hide-inputs
                        hide-mode-switch
                        hide-sliders
                        show-swatches
                        swatches-max-height="200"
                      />
                    </v-card-text>
                    <v-card-actions class="d-flex justify-space-between">
                      <v-btn
                        text
                        color="primary"
                        @click="modal.holeColor = false"
                      >
                        {{ $t('actions.discard') }}
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.holeColorDialog.save(object.holeColor)"
                      >
                        {{ $t('actions.ok') }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-col>
              <v-col cols="12" md="6" class="pa-2">
                <v-select
                  v-model="mode"
                  :items="modes"
                  :label="$t('courses.mode.title')"
                  :disabled="!isEditting || typeof object.id === 'string'"
                  outlined
                />
              </v-col>
              <v-col v-if="mode === 'course'" cols="12" class="pa-2">
                <v-select
                  v-model="object.parentId"
                  :items="parentsItems"
                  item-text="text"
                  item-value="id"
                  :label="$t('courses.parentId')"
                  :disabled="!isEditting || object.isExternal"
                  outlined
                  :error="hasErrors('parentId')"
                  :error-messages="getErrors('parentId')"
                />
              </v-col>
              <v-col v-if="!object.parentId" cols="12" class="pa-2">
                <v-btn
                  v-if="isEditting && !object.isExternal"
                  text
                  color="orange darken-2 white--text"
                  @click="drawPolygon(null)"
                >
                  <v-icon class="mr-2">mdi-pencil</v-icon>
                  {{ $t('actions.map.edit') }}
                </v-btn>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col
                v-if="mode === 'course'"
                :cols="mode === 'course' ? 5: 12"
                class="pa-2 d-flex flex-column"
              >
                <span class="title">{{ $t('courses.holes.title') }}</span>
                <v-list
                  class="better-scrollbar pr-4"
                  dense
                  style="overflow-y: auto; height: calc(50vh - 130px);"
                >
                  <template v-for="(hole, i) in object.holes">
                    <v-list-item
                      :key="i"
                      style="border-bottom: 1px solid #CDCDCD;"
                    >
                      <v-list-item-content class="pa-0">
                        <v-list-item-content class="px-1">
                          <v-text-field
                            v-model="hole.name"
                            outlined
                            :label="$t('courses.holes.name')"
                            disabled
                            :error="hasErrors(`holes.${i}.name`)"
                            :error-messages="getErrors(`holes.${i}.name`)"
                          />
                        </v-list-item-content>
                        <v-list-item-content class="px-1">
                          <v-text-field
                            v-model="hole.par"
                            type="number"
                            min="2"
                            outlined
                            :label="$t('courses.holes.par')"
                            :disabled="!isEditting"
                            :error="hasErrors(`holes.${i}.par`)"
                            :error-messages="getErrors(`holes.${i}.par`)"
                          />
                        </v-list-item-content>
                      </v-list-item-content>
                      <v-list-item-content class="pa-0">
                        <v-list-item-content class="px-1">
                          <v-text-field
                            v-model="hole.cup.latitude"
                            type="number"
                            min="2"
                            outlined
                            :label="$t('courses.cup.latitude')"
                            :disabled="!isEditting"
                            :error="hasErrors(`holes.${i}.cup.latitude`)"
                            :error-messages="getErrors(`holes.${i}.cup.latitude`)"
                          />
                        </v-list-item-content>
                        <v-list-item-content class="px-1">
                          <v-text-field
                            v-model="hole.cup.longitude"
                            type="number"
                            min="2"
                            outlined
                            :label="$t('courses.cup.longitude')"
                            :disabled="!isEditting"
                            :error="hasErrors(`holes.${i}.cup.longitude`)"
                            :error-messages="getErrors(`holes.${i}.cup.longitude`)"
                          />
                        </v-list-item-content>
                      </v-list-item-content>
                      <v-list-item-action class="px-1">
                        <v-tooltip top>
                          <template
                            v-slot:activator="{ on, attrs }"
                          >
                            <v-btn
                              icon
                              v-bind="attrs"
                              v-on="on"
                              @click="openCupDialog(hole.position)"
                            >
                              <v-icon>
                                mdi-crosshairs-gps
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t('courses.hole.location_dialog') }}</span>
                        </v-tooltip>
                      </v-list-item-action>
                      <v-list-item-action>
                        <v-tooltip top>
                          <template
                            v-slot:activator="{ on, attrs }"
                          >
                            <v-btn
                              v-if="isEditting && !object.isExternal"
                              icon
                              color="orange darken-2 white--text"
                              v-bind="attrs"
                              v-on="on"
                              @click="drawPolygon(hole.position)"
                            >
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t('courses.hole.draw_geofence') }}</span>
                        </v-tooltip>
                      </v-list-item-action>
                    </v-list-item>
                  </template>
                </v-list>
              </v-col>
              <v-col :cols="mode === 'course' ? 7: 12" class="pa-2 d-flex flex-column">
                <v-card height="calc(50vh - 100px)" color="green lighten-3" elevation="0">
                  <gm-map
                    ref="coursesMap"
                    v-model="object"
                    :show="dialog"
                    :disabled="!isEditting"
                    :dark="isDark"
                    :mode="mode"
                    map-id="courseMap"
                    class="green lighten-3"
                    width="100%"
                    height="100%"
                  />
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="d-flex justify-space-between">
          <v-btn
            v-if="isEditting"
            :ripple="false"
            outlined
            dark
            color="primary"
            @click="discardItem"
          >
            {{ $t('actions.discard') }}
          </v-btn>
          <v-btn
            v-if="isEditting"
            :ripple="false"
            depressed
            color="primary"
            @click="saveItem(object.id)"
          >
            {{ $t('actions.save') }}
          </v-btn>
          <v-btn
            v-if="!isEditting"
            :ripple="false"
            depressed
            color="orange darken-1 white--text"
            @click="isEditting = true"
          >
            {{ $t('actions.edit') }}
          </v-btn>
        </v-card-actions>
      <!-- <v-card-actions class="d-flex justify-space-between">
        <v-btn
          :ripple="false"
          outlined
          dark
          color="primary"
          @click="discardItem"
        >
          {{ $t('actions.back') }}
        </v-btn>
      </v-card-actions> -->
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="cupDialog"
      scrollable
      max-width="50vw"
    >
      <v-card>
        <v-card-title class="d-flex align-start justify-space-between">
          <p>{{ $t('courses.cup.title') }}</p>
          <v-btn icon @click="discardCupDialog()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="better-scrollbar">
          <v-row no-gutters>
            <v-col cols="12" md="6" class="pa-2">
              <v-text-field
                v-model="cupObject.latitude"
                outlined
                type="number"
                max="90"
                min="-90"
                :label="$t('courses.cup.latitude')"
                :disabled="!isEditting"
                :error="hasErrors(`holes.${cupPosition}.cup`)"
                :error-messages="getErrors(`holes.${cupPosition}.cup`)"
              />
            </v-col>
            <v-col cols="12" md="6" class="pa-2">
              <v-text-field
                v-model="cupObject.longitude"
                outlined
                type="number"
                max="180"
                min="-180"
                :label="$t('courses.cup.longitude')"
                :disabled="!isEditting"
                :error="hasErrors(`holes.${cupPosition}.cup`)"
                :error-messages="getErrors(`holes.${cupPosition}.cup`)"
              />
            </v-col>
            <v-col cols="12" class="pa-2">
              <v-card height="40vh" color="green lighten-3" elevation="0">
                <gm-cup-map
                  ref="cupMap"
                  v-model="cupObject"
                  :show="cupDialog"
                  :disabled="!isEditting"
                  :dark="isDark"
                  map-id="cupMap"
                  class="green lighten-3"
                  width="100%"
                  height="100%"
                />
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="d-flex justify-space-between">
          <v-btn
            :ripple="false"
            outlined
            dark
            color="primary"
            @click="discardCupDialog()"
          >
            {{ $t('actions.discard') }}
          </v-btn>
          <v-btn
            v-if="isEditting"
            :ripple="false"
            depressed
            :disabled="!validateCupCoordinates"
            color="primary"
            @click="saveCupCoordinates()"
          >
            {{ $t('actions.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { orm } from '@/mixins'
import addMutation from '@/graphql/mutations/courses/add.gql'
import editMutation from '@/graphql/mutations/courses/edit.gql'
import Maps from './Maps.vue'
import CupMap from './CupMap.vue'

export default {
  components: {
    'gm-map': Maps,
    'gm-cup-map': CupMap
  },

  mixins: [orm],
  model: {
    prop: 'data',
    event: 'set-object'
  },

  props: {
    showDialog: { type: Boolean, default: () => false },
    data: { type: Object, default: () => {} },
    readonly: {
      type: Boolean,
      default: () => false
    }
  },

  data () {
    return {
      objectMap: {},
      show: false,
      errors: {},
      mode: 'course',
      cupDialog: false,
      cupPosition: 1,
      modal: {
        color: false,
        holeColor: false
      },
      cupObject: {
        latitude: null,
        longitude: null
      }
    }
  },

  computed: {
    ...mapState(['isDark', 'users', 'courses']),

    modes () {
      return [
        { value: 'supercourse', text: this.$i18n.t('courses.mode.supercourse') },
        { value: 'course', text: this.$i18n.t('courses.mode.course') }
      ]
    },

    parentsItems () {
      return this.courses.list.filter(el => el.parentId === null).map(el => {
        return {
          id: el.id,
          text: el.name
        }
      })
    },

    validateCupCoordinates () {
      return this.cupObject.latitude &&
      this.cupObject.longitude &&
      this.cupObject.latitude > -90 &&
      this.cupObject.latitude < 90 &&
      this.cupObject.longitude > -180 &&
      this.cupObject.longitude < 180
    },

    object: {
      get () {
        return this.data
      },

      set (value) {
        this.$emit('toggle-object', value)
      }
    },

    dialog: {
      get () {
        return this.showDialog
      },

      set (value) {
        this.$emit('toggle-dialog', value)
      }
    },

    isEditting: {
      get () {
        return !this.readonly
      },

      set (value) {
        this.$emit('set-readonly', value)
      }
    },

    title () {
      return this.object.id === null ? this.$i18n.t('courses.new') : this.$i18n.t('courses.view')
    },

    objectColor () {
      return this.object.color
    },

    objectHoleColor () {
      return this.object.holeColor
    },

    objectParentId () {
      return this.object.parentId
    }
  },

  watch: {
    objectColor (v) {
      if (v) {
        this.setColor()
      }
    },

    objectHoleColor (v) {
      if (v) {
        this.setColor()
      }
    },

    mode (v) {
      setTimeout(() => {
        if (this.dialog) {
          this.cleanPolygons()
        }
        if (v === 'course') {
          this.initializeHoles()
        } else {
          this.object.parentId = null
        }
      }, 0)
    },

    isEditting (v) {
      setTimeout(() => {
        if (v && this.dialog) {
          this.setPolygon()
        }
      }, 0)
    },

    dialog (value) {
      if (value) {
        if (!(this.object.id)) {
          // si el id es nulo
          this.mode = 'course'
          this.initializeHoles()
        } else {
          // posee un id
          if (!this.object.parentId) {
            // parent id es nulo
            if (this.object.holes[0]) {
              // tiene mas de un hoyo
              this.mode = 'course'
            } else {
              this.mode = 'supercourse'
            }
          } else {
            // si tiene parent id
            this.mode = 'course'
          }
          setTimeout(() => {
            if (value && this.isEditting) {
              this.setPolygon()
            }
          }, 0)
        }
      } else {
        this.object = Object.assign({}, this.$store.getters['courses/defaultObject'])
      }
    }
  },

  created () {
    this.cupObject = Object.assign({}, this.$store.getters['courses/cupDefaultObject'])
  },

  mounted () {
    if (this.object.parentId === null) {
      this.mode = 'supercourse'
    } else {
      this.mode = 'course'
    }
  },

  methods: {
    async saveItem (id) {
      this.isLoading = true
      const data = {
        id: id,
        name: this.object.name,
        color: this.object.color,
        holeColor: this.object.holeColor,
        parentId: this.object.parentId,
        points: this.object.points,
        holes: this.object.holes
      }
      data.points.forEach(point => { delete point.__typename })
      data.holes.forEach(hole => {
        delete hole.__typename
        hole.points.forEach(point => { delete point.__typename })
      })
      if (id) {
        await this.edit(data)
      } else {
        await this.add(data)
      }
    },

    evaluateResponse ({ status, errors, result, action }) {
      this.isLoading = false
      console.log(status, errors)
      switch (status) {
        case 'OK':
          this.resetErrors()
          this.isEditting = false
          // this.drawPolygon()
          this.cleanPolygons()
          this.repaintPolygon()

          this.$store.commit('toggleSnackbar', {
            color: 'green darken-2',
            message: this.$t('helpers.save.success')
          })
          if (action === 'add' || action === 'edit') {
            this.$store.dispatch('courses/getList', true)
          }
          break
        case 'UNPROCESSABLE':
          this.errors = this.parseErrors(errors)
          this.$store.commit('toggleSnackbar', {
            color: 'orange darken-2',
            message: this.$t('errors.invalidFields')
          })
          break
        case 'BADREQUEST':
          this.errors = this.parseErrors(errors)
          this.$store.commit('toggleSnackbar', {
            color: 'orange darken-2',
            message: this.$t('errors.invalidFields')
          })
          break
        case 'LIMITREACHED':
          this.$store.commit('toggleSnackbar', {
            color: 'orange darken-2',
            message: this.$t('errors.limit_reached')
          })
          break
      }
    },

    add (data) {
      const action = 'add'
      this.$apollo.mutate({
        mutation: addMutation,
        variables: {
          token: this.users.entity.token,
          data
        },
        fetchPolicy: 'no-cache'
      }).then(response => {
        const { status, errors, result } = response.data.addCourse
        this.evaluateResponse({ status, errors, result, action })
      }).catch(err => {
        console.log('Error handled', err)
        this.$store.commit('toggleSnackbar', {
          color: 'red darken-2',
          message: this.$t('helpers.errors.disaster')
        })
      })
    },

    edit (data) {
      const action = 'edit'
      this.$apollo.mutate({
        mutation: editMutation,
        variables: {
          token: this.users.entity.token,
          data: this.cleanDataForEdit(data)
        },
        fetchPolicy: 'no-cache'
      }).then(response => {
        const { status, errors, result } = response.data.editCourse
        this.evaluateResponse({ status, errors, result, action })
      }).catch(err => {
        console.log('Error handled', err)
        this.$store.commit('toggleSnackbar', {
          color: 'red darken-2',
          message: this.$t('helpers.errors.disaster')
        })
      })
    },

    cleanDataForEdit (data) {
      data.holes = data.holes.map(hole => {
        delete hole.cup.__typename
        hole.cup.latitude = parseFloat(hole.cup.latitude)
        hole.cup.longitude = parseFloat(hole.cup.longitude)
        return hole
      })
      // console.log('sended data: ', data)
      return data
    },

    discardItem () {
      this.dialog = false
      this.object = Object.assign({}, this.$store.getters['courses/defaultObject'])
      this.resetErrors()
      setTimeout(() => {
        this.$refs.coursesMap.cleanPolygons()
      }, 0)
    },

    drawPolygon (key) {
      console.log('drawing polygon')
      setTimeout(() => {
        this.$refs.coursesMap.drawPolygon(key)
      }, 0)
    },

    cleanPolygons () {
      console.log('clean polygons')
      setTimeout(() => {
        this.$refs.coursesMap.cleanPolygons()
      }, 0)
    },

    initializeHoles () {
      if (!this.object.id) {
        this.object.holes = Array(9).fill({}).map((_, i) => {
          return {
            position: i + 1,
            name: `Hole #${i + 1}`,
            points: [],
            par: null,
            cup: {
              latitude: 0,
              longitude: 0
            }
          }
        })
      }
    },

    repaintPolygon () {
      this.$refs.coursesMap.initializeHoles()
    },

    setColor () {
      setTimeout(() => {
        this.$refs.coursesMap.setColor()
      }, 0)
    },

    setPolygon () {
      console.log('setPolygon')
      setTimeout(() => {
        this.$refs.coursesMap.setPolygon()
      }, 0)
    },

    openCupDialog (position) {
      this.cupDialog = true
      this.cupPosition = position
      this.cupObject.latitude = this.object.holes[this.cupPosition - 1].cup.latitude
      this.cupObject.longitude = this.object.holes[this.cupPosition - 1].cup.longitude
    },

    discardCupDialog () {
      this.cupDialog = false
      this.cupPosition = 1
      this.cupObject = Object.assign({}, this.$store.getters['courses/cupDefaultObject'])
    },

    saveCupCoordinates () {
      if (this.cupObject.latitude && this.cupObject.longitude) {
        this.object.holes[this.cupPosition - 1].cup.latitude = this.cupObject.latitude
        this.object.holes[this.cupPosition - 1].cup.longitude = this.cupObject.longitude
        this.discardCupDialog()
      }
    }
  }
}
</script>
